import * as React from 'react';
import {Link} from 'react-router-dom'
import {
  Box,
  Card,
  Typography,
  Divider,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  IconButton
} from '@mui/material'

import { useSelector, useDispatch } from 'react-redux';

import EventNoteIcon from '@mui/icons-material/EventNote';
import EditNoteRoundedIcon from '@mui/icons-material/EditNoteRounded';
import HighlightOffRoundedIcon from '@mui/icons-material/HighlightOffRounded';
import ConstructionRoundedIcon from '@mui/icons-material/ConstructionRounded';

import { CSettingButton } from '../components/common/Modal';

import TitleModal from '../modals/TitleModal';
import ScheduleModal from '../modals/ScheduleModal';
import Toolbar from '../components/Toolbar'

import { getList, createVisualization, updateVisualization, deleteVisualization } from '../slices/visualization';

export default function Visualization() {
  const visualizations = useSelector(state => state.visualization.list);
  const [title, setTitle] = React.useState('');
  const [id, setId] = React.useState('');
  const [openVisual, setOpenVisual] = React.useState(false);
  const [openSchedule, setOpenSchedule] = React.useState(false);

  const dispatch = useDispatch();

  React.useEffect(() => {
    dispatch(getList());
  }, [dispatch]);

  const handleCreateVisualization = () => {
    setOpenVisual(true);
  }

  const handleDeleteVisualization = (id) => {
    if(window.confirm('Do you really want to remove the visualization?')) {
      dispatch(deleteVisualization({id}))
    }
  }

  const handleUpdateVisualization = (tid, name) => {
    setTitle(name);
    setId(tid);
    setOpenVisual(true);
  }

  const handleUpdateSchedule = (id) => {
    setOpenSchedule(true);
    setId(id)
  }

  const handleCloseVisual = (e) => {
    setOpenVisual(false);
  }

  const handleCloseSchedule = (e) => {
    setOpenSchedule(false);
  }

  const handleSaveVisualization = (name) => {
    if(title === '')
      dispatch(createVisualization({name}))
    else
      dispatch(updateVisualization({id, name}))
    setTitle('');
    setOpenVisual(false);
  }

  return (
    <Box className="w-full h-full ">
      <Toolbar/>
      <Box className="content-height" sx={{padding: 4}}>
        <Card className='h-full flex flex-column border-content' sx={{boxShadow: 'rgba(145, 158, 171, 0.3) 0px 0px 2px 0px, rgba(145, 158, 171, 0.12) 0px 12px 24px -4px'}}>
          <Box className='flex flex-row align-center' sx={{padding: 3, flexGrow: 0}}>
            <Typography variant='h6' sx={{flexGrow: 1}}>Visualization</Typography>
            <Box
              className="w-full flex"
              sx={{
                alignItems: 'center',
                justifyContent: 'flex-end',
                gap: 1
              }}
            >
              <CSettingButton
                sx={{
                  background: '#5D87FF',
                  color: 'white',
                  padding: '0.25rem 1rem',
                  '&:hover': {
                    background: '#6695FF'
                  }
                }}
                onClick={handleCreateVisualization}
              >
                New Visualization
              </CSettingButton>
            </Box>
          </Box>
          <Divider/>
          <Box className='h-full'>
            <List sx={{padding: 0}}>
              {visualizations && visualizations.length>0 && visualizations.map(item => (
                <ListItem
                  key={item.id}
                  disableGutters
                  secondaryAction={
                    <Box
                      sx={{
                        marginRight: 8,
                      }}
                    >
                      <IconButton 
                        size='small' 
                        aria-label="Edit" 
                        sx={{
                          borderRadius: 2, 
                          color: '#4CAF50'
                        }} 
                        onClick={() => handleUpdateVisualization(item.id, item.name)}
                      >
                        <EditNoteRoundedIcon />
                      </IconButton>
                      <IconButton 
                        size='small' 
                        aria-label="Edit" 
                        sx={{
                          borderRadius: 2, 
                          color: '#00A4EF'
                        }} 
                        onClick={() => handleUpdateSchedule(item.id)}
                      >
                        <EventNoteIcon />
                      </IconButton>
                      <IconButton 
                        size='small' 
                        aria-label="Delete" 
                        sx={{
                          borderRadius: 2, 
                          color: '#EB7A8E'
                        }} 
                        onClick={() => handleDeleteVisualization(item.id)}
                      >
                        <HighlightOffRoundedIcon />
                      </IconButton>
                    </Box>
                  }
                  sx={{
                      borderBottom: '1px solid #C1C1C1',
                      padding: 0
                  }}
                >
                  <ListItemButton
                    sx={{
                      paddingY: '0.8rem',
                      paddingLeft: '1rem',
                      paddingRight: '2rem',
                    }}
                    component={Link}
                    to={`/visualization/${item.id}`}
                  >
                    <ListItemIcon sx={{minWidth: '40px', padding: 1, borderRadius: 2, color: '#00A4EF'}}>
                      <ConstructionRoundedIcon />
                    </ListItemIcon>
                    <ListItemText primary={item.name} />
                  </ListItemButton>
                </ListItem>
              ))}
            </List>
          </Box>
        </Card>
      </Box>
      <TitleModal 
        open={openVisual}
        value={title}
        caption={'New Visualization'}
        handleSave={handleSaveVisualization}
        handleClose={handleCloseVisual}
      />
      <ScheduleModal
        open={openSchedule}
        id={id}
        type={'visualization'}
        handleSave={handleSaveVisualization}
        handleClose={handleCloseSchedule}
      />
    </Box>
  );
}